import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
//Import Context
import { AppContext } from "../../../contexts/AppContext";
//Import Component
import RequestHistoryItem from "./RequestHistoryItem";
import ViewPurchaseRequestForm from '../../Forms/PurchaseForm/ViewPurchaseRequestForm';
import ViewFeeContractForm from "../../Forms/FeeContractForm/ViewFeeContractForm";
//Import Helpers
import { formatCurrency, formatDisplayName, getSubventionNames } from "../../../shared/helpers";
//Import Icons
import arrowSide from '../../../assets/icons/arrowSide.svg';
import documentIcon from '../../../assets/icons/document.svg';
//Import CSS
import './requestTracking.css';

function RequestTracking() {
    //UseLocation - useNavigate - useParams
    const location = useLocation();
    const navigate = useNavigate();
    const { establishment, returnState } = location.state || {};
    const { id } = useParams();
    //UseContext
    const { requestsList, pmeList, establishmentList } = useContext(AppContext);
    //UseState
    const [request, setRequest] = useState(null);
    const [activity, setActivity] = useState(null);
    const [showViewPurchaseRequest, setShowViewPurchaseRequest] = useState(false);
    
    useEffect(() => {
        if (id) {
            const findRequest = requestsList.find(request => request.id === id);
            setRequest(findRequest);
            const findPME = pmeList.find(pme => pme.id === findRequest.idPME);
            if (findPME) {
                const findActivity = findPME.activities.find(activity => activity.id === findRequest.idActivity);
                setActivity(findActivity)
            }
        }
    }, [requestsList, pmeList, id]);

    const returnHandler = (e) => {
        e.preventDefault();
        if (returnState) {
            // Navegar de vuelta a la ruta anterior con el estado preservado
            navigate(returnState.previousPath, {
                state: returnState
            });
        } else {
            // Comportamiento por defecto si no hay returnState
            navigate(-1);
        }
    };

    const handleViewFormClick = () => {
        setShowViewPurchaseRequest(true);
    };

    const handleClosePurchaseForm = () => {
        setShowViewPurchaseRequest(false);
    };

    return (
        <section className='container-activity-tracking flex'>
            <article className='info-request flex'>
                <h3>{establishment}</h3>
                <img src={arrowSide} className='icon' alt='Icono de flecha' />
                <p className='text-highlight'>Seguimiento de Solicitudes</p>
                <img src={arrowSide} className='icon' alt='Icono de flecha' />
                <p>
                    {`Solicitud Folio ${request?.typeOfRequest === 'payment'
                        ? requestsList.find(req => req.id === request.originRequestId)?.requestDetails?.folio
                        : request?.requestDetails?.folio}`}
                </p>
            </article>
            <article className='details-request flex'>
                <table>
                    <thead>
                        <tr>
                            <td>Nombre de la Acción</td>
                            <td>Subvención</td>
                            <td>Monto PME</td>
                            <td>{request?.typeOfRequest === 'payment' ? 'Monto O.C' : 'Monto Solicitud'}</td>
                            <td>Gasto Devengado</td>
                            <td>Gasto Efectivo</td>
                            <td>Saldo Devengado</td>
                            <td>Saldo Efectivo</td>
                            <td>Ver Form.</td>
                        </tr>
                    </thead>
                    <tbody>
                        {(activity && request) && (
                            <tr>
                                <th data-label='Nombre de la Acción'>{formatDisplayName(activity?.nameOfAction)}</th>
                                <th data-label='Subvención'>{getSubventionNames(activity?.subsidies)}</th>
                                <th data-label='Monto PME'>{formatCurrency(activity?.totalSubsidyAmount)}</th>
                                <th data-label={request?.typeOfRequest === 'payment' ? 'Monto O.C' : 'Monto Solicitud'}>
                                    {formatCurrency(request?.typeOfRequest === 'payment'
                                        ? request?.purchaseOrderAmount
                                        : request?.requestDetails?.requestAmount)}
                                </th>
                                <th data-label='Gasto Devengado'>{formatCurrency(activity?.accruedExpense)}</th>
                                <th data-label='Gasto Efectivo'>{formatCurrency(activity?.accruedBalance)}</th>
                                <th data-label='Saldo Devengado'>{formatCurrency(activity?.effectiveExpense)}</th>
                                <th data-label='Saldo Efectivo'>{formatCurrency(activity?.effectiveBalance)}</th>
                                <th data-label='Ver Formulario'>
                                    <img
                                        src={documentIcon}
                                        className='icon'
                                        alt='Icono para ver formulario'
                                        onClick={handleViewFormClick}
                                    />
                                </th>
                            </tr>
                        )}

                    </tbody>
                </table>
            </article>
            <article className='request-history flex'>
                <p className='bold'>Historial de Solicitud</p>
                <article className='box-history flex'>
                    {request && request.history && request.history.map((historyItem, index) => {
                        // Determinar si hay una OC activa verificando si algún item anterior o el actual tiene purchaseOrderAmount
                        const hasActivePO = request.history
                            .slice(0, index + 1)
                            .some(item => item.purchaseOrderAmount);
                        return (
                            <RequestHistoryItem
                                key={index}
                                historyItem={historyItem}
                                requestDetails={request?.typeOfRequest === 'payment' ? requestsList.find(req => req.id === request?.originRequestId).requestDetails : request?.requestDetails}
                                isPaymentRequest={true}
                                hasActivePO={hasActivePO}
                            />
                        )
                    })}
                </article>
            </article>
            <article className='box-button flex'>
                <button className='button' onClick={returnHandler}>Volver</button>
            </article>
            {(showViewPurchaseRequest && request) && (
                request?.typeOfRequest === 'feeContract' ? (
                    <ViewFeeContractForm
                        onClose={handleClosePurchaseForm}
                        requestDetails={{
                            request: request,
                            activity: activity
                        }}
                        establishmentList={establishmentList}
                        fromRequestTracking={true}
                    />
                ) : (
                    <ViewPurchaseRequestForm
                        onClose={handleClosePurchaseForm}
                        requestDetails={{
                            request: request,
                            activity: activity
                        }}
                        establishmentList={establishmentList}
                        isPaymentRequest={request?.typeOfRequest === 'payment' ? true : false}
                        fromRequestTracking={true}
                    />
                )
            )}
        </section>
    );
};

export default RequestTracking;